/**
 * @author NikolaV
 */
import { latLonToEN } from '@openlayers/ol-utils';
import { Ajax } from '@shared/Ajax';
import { Events } from '@shared/Events';
import { FilesService } from '@shared/services/FilesService';
import { UsersService } from '@shared/services/UsersService';
import { LStorage } from '@shared/Storage';
import { Notify } from '@shared/ui-native/Notify';
import { transform as olTransform } from 'ol/proj';
import { mapUI, mapWrapper } from './map';


export function processUrlParams() {
    const vars: any = utils.getUrlVars();

    // EDIT IMAGE LOCATION
    if (vars.newImageLocation && $.isNumeric(vars.imageId)) {

        $('#newImageLocationTitle').show();

        mapWrapper.events.onClick(e => {
            const coord = mapWrapper.getInstance().getEventCoordinate(e);
            const [lon, lat] = olTransform(e.coordinate, 'EPSG:3857', 'EPSG:4326');

            location.href = `edit_image_${vars.imageId}.htm?lat=${lat}&lon=${lon}`;
        });
    }

    // VIEW SINGLE MODEL
    else if ($.isNumeric(vars.modelId)) {
        FilesService.getDetails(vars.modelId).then(file => {
            if (file && file.model && file.model.name) {
                const ext = utils.getExtensionFromFilename(file.model.name);
                if (/nfcl|pdf|txt|doc|xls|docx|xlsx/.test(utils.getExtensionFromFilename(file.model.name))) {
                    loadDocument(file.model.id);
                } else if (FilesService.isPhoto(file.model.name)) {
                    loadImage(vars.modelId);
                } else {
                    loadModel(vars.modelId, true);
                }
            }
        });
    }

    // VIEW SINGLE IMAGES
    //  loaded from DocumentsImagesStoreAbstract since they need to be loaded first

    // VIEW LOGPOINT(S), CSV ID's, legacy, before we had uuid's
    else if (vars.logpointId) {
        loadLogpointIds(vars.logpointId);
    }

    // VIEW LOGPOINT(S), BY FILTER
    else if (vars.action && vars.action === 'show-logpoints-by-filter') {
        const selectionRaw = LStorage.getItem('map-show-logpoints-filter');
        if (selectionRaw) {
            try {
                const selection = JSON.parse(selectionRaw);
                if (selection.projectId == kuura.getProjectId()) {
                    if (selection.items) { // load csv ids
                        loadLogpointIds(selection.items);
                        // dont clear lstorage here, selection needs to be persisted inside saved-views
                    } else { // load filter
                        Notify.success('Loading logpoints...');
                        Ajax({
                            url: 'api/1/logpoint/filter.json',
                            method: 'POST',
                            data: selection.filter + '&shape=ajax_logpoint&projectId=' + kuura.getProjectId()
                        }).done(resp => {
                            const loadedLogpointsFeatures = mapWrapper.featureLayers.logpoints.drawAll(resp.logpoints)?.features;
                            loadedLogpointsFeatures.forEach(l => l.set('forceShow', true));
                            mapWrapper.fitLogpointsLayer();
                            LStorage.setItem('map-show-logpoints-filter', {
                                timestamp: Date.now(),
                                projectId: kuura.getProjectId(),
                                items: loadedLogpointsFeatures.map(f => f.get('data').id).join(',') // turn 'filter' into items so we can sae them into saved state
                            });
                        }).fail(() => {
                            Notify.warn('Failed to load logpoints')
                        });
                    }
                }
            } catch { }
        } else {
            LStorage.removeItem('map-show-logpoints-filter')
        }
    }

    Events.on('load-image', (svt, data: IImage) => loadImage(data.id));
    Events.on('load-document', (svt, data: IDocument) => loadDocument(data.id));
    Events.on('load-model', (svt, id: number) => loadModel(id, false));
}

// Check and offer user to switch project is the model is located in another project
// they have links in pdf reports and emails
function loadModel(id: number, projectCheck = true) {
    FilesService.getProjectForFileId(id)
        .done(project => {
            if (!project) {
                return;
            }

            FilesService.getDetails(id).then(file => {
                if (project.id == kuura.getProjectId()) {
                    if (kuuraModel.isMap(file.model)) {
                        mapUI.mapPanels.activatePanelById('bgMaps');
                        mapUI.mapPanels.panels.bgMaps.tree.checkIds([id]);

                        Ajax({
                            url: '/api/1/project/' + kuura.getProjectId() + '/model_locations.json',
                        }).done(resp => {

                            const loc = resp.locations?.find(l => l.modelId == id);
                            if (loc) {
                                mapWrapper.setCenter(latLonToEN(loc.modelLocation.lat, loc.modelLocation.lon));
                            }
                        });
                    } else {
                        const promise = mapUI.mapPanels.panels.models.loadModelWithPreload(file.model?.headUuid);
                        if (promise) {
                            promise.then(() => {
                                    mapWrapper.fitFeatureById(id);
                                    mapUI.mapPanels.focusFeatureInTree(id);
                                    mapWrapper.featureLayers.logpoints.fetchAndDrawFile(id);
                                }).catch((e) => {
                                    console.log('url load model:', e);
                                    Notify.warn('Can\'t load model')
                                });
                            }
                        }
                } else {
                    const confirmMsg = kuura.getMessage('js_files.show_file_switch_project', project.name);
                    UsersService.changeProjectWithConfirm(project.id, confirmMsg);
                }
            });
        })
        .fail(() => Notify.error(kuura.getMessage('general.validation.access_not_allowed')));
}

function loadImage(id: number) {
    const image = mapWrapper.featureLayers.images.openImageById(id);
}

function loadDocument(id: number) {
    const documents = mapWrapper.featureLayers.documents.openDocumentById(id);
}

async function loadLogpointIds(idsCsv: string) {
    const ids: number[] = idsCsv
        .split(',')
        .map(id => parseInt(id, 10));

    if (Array.isArray(ids)) {
        const result = await mapWrapper.featureLayers.logpoints.fetchAndDrawMultiple(ids);
        if (result.features?.length) {
            result.features.forEach(f => f.set('forceShow', true));
            mapWrapper.fitLogpointsLayer();
        }
    }
}
